"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function configureFaqModule($locationProvider, $stateProvider) {
    var faqRootState = {
        url: '/faq',
        templateUrl: '/u/faq-root.html',
        resolve: {
            faqGroups: ['faqApi',
                function (faqApi) {
                    return faqApi.getFaq(function (faqGroups) {
                        return faqGroups;
                    }, function () {
                        return null;
                    });
                }],
            selectedSubgroup: function () {
                return {};
            },
            searchResults: function () {
                return {};
            }
        },
        controller: 'faqQuestionsCtrl'
    };
    var faqHomeState = {
        url: '/home',
        templateUrl: '/u/faq-home.html',
        controller: 'faqCtrl'
    };
    var faqSupportTicketState = {
        url: '/new-ticket',
        templateUrl: '/u/faq-support-ticket.html',
        controller: 'faqSupportTicketCtrl',
        controllerAs: 'vm'
    };
    var faqSubgroupsState = {
        url: '/questions/{subgroupId}',
        templateUrl: '/u/faq-subgroup.html',
        resolve: {
            selectedSubgroup: ['faqApi', '$stateParams',
                function (faqApi, $stateParams) {
                    return faqApi.getAllSubgroups({ id: $stateParams.subgroupId }, function (subgroup) {
                        return subgroup;
                    }, function () {
                        return null;
                    });
                }]
        },
        controller: 'faqQuestionsCtrl'
    };
    var questionState = {
        url: '/{questionId}'
    };
    var faqSearchResultsState = {
        url: '/search/{keyword}',
        templateUrl: '/u/faq-search.html',
        resolve: {
            searchResults: ['searchApi', '$stateParams',
                function (searchApi, $stateParams) {
                    var query = $stateParams.keyword;
                    if (!query) {
                        return null;
                    }
                    return searchApi.getFaqResults({ keyword: query }, function (result) { return result; }, function () { return null; });
                }]
        },
        controller: 'faqQuestionsCtrl'
    };
    var configureLocationProvider = function ($locationProvider) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
    };
    var configureStateProvider = function ($stateProvider) {
        $stateProvider
            .state('faq', faqRootState)
            .state('faq.home', faqHomeState)
            .state('faq.supportTicket', faqSupportTicketState)
            .state('faq.subgroups', faqSubgroupsState)
            .state('faq.subgroups.question', questionState)
            .state('faq.searchResults', faqSearchResultsState);
    };
    configureLocationProvider($locationProvider);
    configureStateProvider($stateProvider);
}
exports.configureFaqModule = configureFaqModule;
//# sourceMappingURL=data:application/json;base64,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